var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showPublished)?_c('i',{staticClass:"fas fa-globe mr-2",attrs:{"title":"AKTUALISIERT"}}):_vm._e(),(_vm.showDeactivated)?_c('i',{staticClass:"fas fa-ban mr-2",attrs:{"title":"DEACTIVATED"}}):_vm._e(),(_vm.showEdit)?_c('i',{staticClass:"fas fa-pen",attrs:{"title":"EDIT"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }